import PropTypes from "prop-types";
import React from "react";

const NoPermissionManager = () => {

  return (
    <div className="nip-overlay">
      <div className="nip-overlay-box">
        <h1>No Access</h1>
        <p>
          You don't have access to fill the IP Permit form yet. Please check back when a request is sent
        </p>
      </div>
    </div>
  );
};

NoPermissionManager.propTypes = {
  isSending: PropTypes.any,
  requestStatus: PropTypes.any,
  submitRequest: PropTypes.func
}

export default NoPermissionManager;
